import React, { useCallback } from "react"
import Select from "@infotech/uikit-select"
import "react-select/dist/react-select.css"
import debounce from "lodash/debounce"

const InfinitySelect = props => {
  const {
    isClearable,
    infinityConfig: {
      changeQuery,
      queryParams,
      searchBy,
      searchExtraQuery,
      stopLoad,
    },
  } = props
  let request
  const search = string => {
    clearTimeout(request)
    if (string) {
      request = setTimeout(
        () =>
          changeQuery({
            ...queryParams,
            limit: 30,
            ...{
              query: `${
                searchExtraQuery ? `${searchExtraQuery};` : ``
              }${searchBy}=="*${string}*"`,
            },
          }),
        1000,
      )
    } else {
      changeQuery(
        searchExtraQuery
          ? {
              query: searchExtraQuery,
              limit: 30,
              offset: 0,
            }
          : {
              limit: 30,
              offset: 0,
            },
      )
    }
  }

  const load = () => {
    if (!stopLoad) {
      changeQuery({
        ...queryParams,
        limit: queryParams.limit + 30,
      })
    }
  }
  const changeSearchDebounced = useCallback(debounce(search, 300), [search])
  return (
    <Select
      {...props}
      clearable={isClearable}
      onInputChange={changeSearchDebounced}
      onMenuScrollToBottom={load}
    />
  )
}

export default InfinitySelect
